module.exports = __webpack_public_path__ + "Sonia_Silva_Web_Over.jpg?9a8e4f3af760b3cce462f6e0965ed0b1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/Sonia_Silva_Web_Over.jpg
// module id = 179
// module chunks = 0